/**
 * Объединяет два массива объектов, используя поле 'sku' для уникальности.
 * При совпадении 'sku' приоритет отдается объекту из второго массива (SPOList).
 * * @param {Array<Object>} existingItems - Первый массив (меньший приоритет).
 * @param {Array<Object>} SPOList - Второй массив (более высокий приоритет).
 * @returns {Array<Object>} Объединенный массив.
 */
function mergeArraysWithPriority(existingItems, SPOList) {
  const mergedMap = new Map();


  for (const item of existingItems) {
    if (item.sku) {
      mergedMap.set(item.sku, item);
    }
  }

  for (const item of SPOList) {
    if (item.sku) {
      mergedMap.set(item.sku, item);
    }
  }

  return Array.from(mergedMap.values());
}

export default mergeArraysWithPriority